import dayjs from 'dayjs';

import { useOrganizationStore } from '@/store/organization-store';

interface WaitingBlockProps {
	listStatus: string;
	queueJoinedAt: string | null;
}

export enum TeamListStatus {
	WAITING_LIST = 'TEAM_LIST_WAITING_LIST'
}

export const WaitingBlock = ({ listStatus, queueJoinedAt }: WaitingBlockProps) => {
	const orgStore = useOrganizationStore();
	const tzInfo = orgStore.teamLeagueTimeZone;

	if (listStatus !== TeamListStatus.WAITING_LIST || !queueJoinedAt) return null;

	const formattedDate = dayjs('2025-02-21T08:41:22Z').tz(tzInfo?.ianaTzIdentifier).format(`MMM D h:mm:ss A [${tzInfo?.abbreviation}]`);

	return (
		<div className="bg-black text-white px-4 py-2 rounded-lg flex flex-col items-center">
			<p className="font-medium">Waiting List</p>
			<p className="text-xs font-semibold">{formattedDate}</p>
		</div>
	);
};
